
import React, { useState } from 'react';

import { AppBar, Box, Tab, Tabs, Typography } from '@mui/material';

import IData from '../../shared/IData';
import CampaignContent from './CampaignContent';
import CampaignStatistics, { IPlatformStatistics } from './CampaignStatistics';
import Styles from '../../lib/Styles';
import classes from './ViewTabSection.module.scss';

export interface IViewTabSectionProps {
    data: IData | undefined;
    platformStatistics: IPlatformStatistics | undefined;
}

export default function ViewTabSection(props: IViewTabSectionProps ) {
  const { data, platformStatistics } = props;
  const cx = new Styles(classes).cx;

  const [value, setValue] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    );
  }

  function a11yProps(index: any) {
    return {
      id: `tab-${index}`,
      "aria-controls": `tabpanel-${index}`
    };
  }

  return (
    <div className={cx('root')}>
      <AppBar position="static" className={cx('appBar1')}>
        <Tabs
          centered
          value={value}
          onChange={handleChange}
          aria-label="Select Campaign or Statistics"
        >
          <Tab label="Campaign" {...a11yProps(0)} />
          <Tab label="Statistics" {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <CampaignContent data={data} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <CampaignStatistics platformStatistics={platformStatistics ? platformStatistics : undefined} />
      </TabPanel>

    </div>
  );
};
